"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentAssignment = void 0;
var AssessmentAssignment;
(function (AssessmentAssignment) {
    AssessmentAssignment["ASSIGNED_TO_ANYONE"] = "ASSIGNED_TO_ANYONE";
    AssessmentAssignment["ASSIGNED_TO_ME"] = "ASSIGNED_TO_ME";
    AssessmentAssignment["UNASSIGNED"] = "UNASSIGNED";
    AssessmentAssignment["ALL"] = "ALL";
})(AssessmentAssignment = exports.AssessmentAssignment || (exports.AssessmentAssignment = {}));
//# sourceMappingURL=stormDocumentAssessorState.js.map